import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./LuckySpin.css";
import LuckySpinTicketQRModal from "../../components/CustomModal/LuckySpinTicketQRModal";
import LuckySpinPhysicalProductModal from "../../components/CustomModal/LuckySpinPhysicalProductModal";
import LuckySpinTryAgainModal from "../../components/CustomModal/LuckySpinTryAgainModal";
import LuckySpinWinPointModal from "../../components/CustomModal/LuckySpinWinPointModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import swal from "sweetalert";
import { publicIp } from "public-ip";

const LuckySpin = () => {





  const location = useLocation();
  const [wheelData, setWheelData] = useState({
    0: { key: "0", title: "Try Again", callback: { func: "tryAgain", args: "" } },
    1: { key: "1", title: "Try again", callback: { func: "tryAgain", args: "" } },
    2: { key: "2", title: "iPhone 16 Pro Max",  callback: { func: "tryAgain", args: "" }},
    3: { key: "3", title: "Try Again",  callback: { func: "tryAgain", args: "" }  },
    4: { key: "4", title: "Try Again", callback: { func: "tryAgain", args: "" } },
    5: { key: "5", title: "Samsung TV 42",  callback: { func: "tryAgain", args: "" }},
    6: { key: "6", title: "Try Again",  callback: { func: "tryAgain", args: "" } },
    7: { key: "7", title: "Cap", callback: { func: "wonCap", args: "Congratulations - You have won a Cap" } },
    8: { key: "8", title: "Try again", callback: { func: "tryAgain", args: "" } },
    9: { key: "9", title: "Try Again", callback: { func: "tryAgain", args: "" }},
    10: { key: "10", title: "Smartphone (Samsung)", callback: { func: "wonSmartPhone", args: "Congratulations - You have won a Smartphone" } },
    11: { key: "11", title: "Power Bank",  callback: { func: "wonPowerBank", args: "Congratulations - You have won a Power Bank" } },
  });

  const [giftCode, setGiftCode] = useState("");
  const [submitConditionModal, setSubmitConditionModal] = useState(false);
  const [referConditionModal, setReferConditionModal] = useState(false);
  const [giftCodeModal, setGiftCodeModal] = useState(false);
  const [referModal, setReferModal] = useState(false);
  const [ticketQRModal, setTicketQRModal] = useState(false);
  const [physicalProductModal, setPhysicalProductModal] = useState(false);
  const [winPhysicalProduct, setWinPhysicalProduct] = useState(null);
  const [physicalProductForm, setPhysicalProductForm] = useState({});
  const [wheelWinInfo, setWheelWinInfo] = useState(null);
  const [tryAgainModal, settryAgainModal] = useState(false);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [limitExceeded, setLimitExceeded] = useState(false);
  const [referCodeToCopy, setReferCodeToCopy] = useState("2346456567768");
  const [submitReferralCode, setSubmitReferralCode] = useState("");
  const [spinSubmit, setSpinSubmit] = useState(true);

  const [referCodes, setReferCodes] = useState([]);

  const [referDoneCodes, setReferDoneCodes] = useState([]);


  // wheel spinning callback
  const callbackAction = {
    async tryAgain() {
      settryAgainModal(true);
    },
    async wonCap() {
      setPhysicalProductModal(true);
      setWinPhysicalProduct("cap");
      setPhysicalProductForm({ product_name: "Cap" });
    },
    async wonPowerBank() {
      setPhysicalProductModal(true);
      setWinPhysicalProduct("power_bank");
      setPhysicalProductForm({ product_name: "Power Bank" });
    },
    async wonSmartPhone() {
      setPhysicalProductModal(true);
      setWinPhysicalProduct("smartPhone");
      setPhysicalProductForm({ product_name: "Smartphone" });
    },
    async freeTicketQatar() {
      setTicketQRModal(true);
      const response = await axios.post("/api/loyalty-wallet", {
        action: "store_wheel_win_history",
        type: "DigitalItem",
        info: "TicketQatar",
        details: "ticket1",
      });
      setWheelWinInfo(response.data.results.original.results);
    },
  };

  const [transitionData, setTransitionData] = useState({
    transform: "rotate(0deg) translateZ(0px)",
  });


  const getExactpoint = async (position) => {
    // Coordinates mapping for random value generation
    const a0 = 1413380.9137958903;
    const b0 = a0 - 27;
    const a1 = 340614.2830057758;
    const b1 = a1 - 28;
    const a3 = 1855190.7637714386;
    const b3 = a3 - 27;
    const a4 = 892584.540347825;
    const b4 = a4 - 28;
    const a6 = 1595000.8257202085;
    const b6 = a6 - 27;
    const a7 = 273110.318002022;
    const b7 = a7 - 27;
    const a8 = 1311024.4639515888;
    const b8 = a8 - 28;
    const a9 = 2341730.568964096;
    const b9 = a9 - 27;
    const a10 = 606564.1764989285;
    const b10 = a10 - 28;
    const a11 = 1123910.3392030033;
    const b11 = a11 - 27;

    switch (position) {
      case 0:
      case 3:
      case 6:
      case 9:
        try {
          const userData = await axios.get("api/user/ticket");
          if(userData.data.status === 404){
            const sessionResponse = await axios.get("api/qatar-ticket/running/session");
            if (sessionResponse.data && sessionResponse.data.remaining !== 0) {
              const hourDataResponse = await axios.post("/api/qatar-ticket/per/hour", { createOrCheck: "get" });
              if (hourDataResponse.data.data !== null) {
                if (hourDataResponse.data.data.ticket === "1") {
                  await axios.post("/api/qatar-ticket/per/hour", { createOrCheck: "create" });
                  return Math.random() * (a0 - b0) + b0;
                } else {
                  return 340614.2830057758;
                }
              } else {
                await axios.post("/api/qatar-ticket/per/hour", { createOrCheck: "create" });
                return Math.random() * (a0 - b0) + b0;
              }
            } else {
              return 340614.2830057758;
            }
          }else{
            return 340614.2830057758;
          }
          
        } catch (error) {
          return 340614.2830057758;
        }

      case 7:
        try {
          const userData = await axios.get("api/user/gift/item");
          if(!userData.data.status){
            const giftCountData = await axios.get("api/gift/item/count");
            if(giftCountData.data.caps >= 10){
              return 340614.2830057758;
            }else{
              const luckyValue = Math.floor(Math.random() * 10) + 1;
              if (luckyValue === 7) {
                return Math.random() * (a7 - b7) + b7;
              } else {
                return 340614.2830057758; 
              }
              
            }
          }else{
            return 340614.2830057758;
          }
          
        } catch (error) {
          return 340614.2830057758;
        }

      case 11:
        try {
          const userData = await axios.get("api/user/gift/item");
          if(!userData.data.status){
            const giftCountData = await axios.get("api/gift/item/count");
            if(giftCountData.data.PowerBanks >= 5){
              return 340614.2830057758;
            }else{
              const luckyValue = Math.floor(Math.random() * 10) + 1;
              if (luckyValue === 11) {
                return Math.random() * (a11 - b11) + b11; 
              } else {
                return 340614.2830057758; 
              }
              
            }
            
          }else{
            return 340614.2830057758;
          }
          
        } catch (error) {
          return 340614.2830057758;
        }

      case 1:
        return a1;
      case 4:
        return a4;
      
      case 8:
        return a8;
      default:
        return 340614.2830057758;
    }
  };

  const [transformRotateDeg, setTransformRotateDeg] = useState(340614.2830057758);
  const [tickerDeg, setTickerDeg] = useState(0);
  const [getCurrentPosition, setCurrentPosition] = useState(null);
  const [prePositionValue, setPrePositionValue] = useState(null);
  const [tryAgainValue, setTryAgainValue] = useState(null);

  const spinSound = new Audio('/spinning_sound.mp3');

  const getReferCode = async () => {
    const response = await axios.post("/api/loyalty-wallet", {
      action: "wheel_referral",
    });
    if (response.status === 200) {
      setReferCodes(JSON.parse(response.data.results.data.codes));
      const usedCodes = response.data.results.data.used_codes;
      setReferDoneCodes(JSON.parse(usedCodes ? usedCodes : ''));
    }
  };


  const spinClicker = async () => {

    if (limitExceeded) {
      swal("Exceeded", "You have exceeded the limits", "error");
      return;
    }

    setSpinSubmit(false);
    spinSound.play();

    const rotateDegree = Math.random() * 360;
    const newRotateDeg = transformRotateDeg + rotateDegree;
    let finalRotateDig = null;

    let newPosition = Math.floor((newRotateDeg % 360) / 30);

    const storedCountryCode = localStorage.getItem('countryCode');
    if(false){
      const spinCount = await axios.get("api/user/while/spin/count");
      if(spinCount.data.wheel_spin_count !== 0){
        const userGiftCheck = await axios.get("api/user/gift/check");
        if(!userGiftCheck.data.check_gift){
          finalRotateDig = await getExactpoint(newPosition);
        }else{
          finalRotateDig = 340614.2830057758;
        }
      }else{
        finalRotateDig = 340614.2830057758;
      }
    }else{
      finalRotateDig = 340614.2830057758;
    }
   

    const possibleValues = [1, 4, 8];
    if (finalRotateDig === 340614.2830057758) {
        do {
            newPosition = possibleValues[Math.floor(Math.random() * possibleValues.length)];
        } while (newPosition === prePositionValue); 
        setPrePositionValue(newPosition);
    }

    if (newPosition === 1 || newPosition === 4 || newPosition === 8) {
        if (tryAgainValue === 1) {
            newPosition = 4;
            finalRotateDig = 892580.540347825;
            setTryAgainValue(4);
        } else if (tryAgainValue === 8) {
            newPosition = 1;
            finalRotateDig = 340610.2830057758;
            setTryAgainValue(1);
        } else {
            newPosition = 8;
            finalRotateDig = 1311020.4639515888;
            setTryAgainValue(8);
        }
    }

    setTransformRotateDeg(finalRotateDig);
    setTransitionData({
        transform: `rotate(${finalRotateDig}deg) translateZ(0px)`,
    });


    setTickerDeg(2);
    setCurrentPosition(wheelData[newPosition]);
};

const spinTransitionEnd = () => {
    getReferCode();
    if (getCurrentPosition && getCurrentPosition.callback) {
        const args = getCurrentPosition.callback.args?.split(",");
        const callbackFunc = getCurrentPosition.callback.func;

        if (typeof callbackAction[callbackFunc] === "function") {
            setTimeout(() => {
                if (args) {
                    callbackAction[callbackFunc](...args); 
                } else {
                    callbackAction[callbackFunc](); 
                }
            }, 800);
        }
    }

    setTickerDeg(0); 
    spinSound.pause();
    spinSound.currentTime = 0;
    setTransformRotateDeg(0); 
    setPrePositionValue(null);
    setSpinSubmit(true);
    updateWheelSpinCount();
};



  const submitPhysicalProduct = async () => {
    const response = await axios.post("/api/loyalty-wallet", {
      action: "store_wheel_win_history",
      type: "PhysicalItem",
      item_tag: winPhysicalProduct,
      details: `
            Product Name: ${winPhysicalProduct}<br/>
            Name: ${physicalProductForm.name}<br/>
            Email: ${physicalProductForm.email}<br/>
            Phone: ${physicalProductForm.phone}<br/>
            Address: ${physicalProductForm.address}
            `,
    });
    if (response.status === 200) {
      setGiftCode(response.data.results.original.results.reference_number)
      setPhysicalProductForm({});
      setPhysicalProductModal(false);
      setGiftCodeModal(true);
    }
  };

  const handlePhysicalProductInput = (e) => {
    setPhysicalProductForm({
      ...physicalProductForm,
      [e.target.name]: e.target.value,
    });
  };

  const updateHomeModalViewed = async () => {
    const query = new URLSearchParams(window.location.search);
    if (query.get("refer") === "modal_home") {
      await axios.post("/api/loyalty-wallet", {
        action: "user_viewed_home_modal",
      });
    }
  };

  const remainingSpinCount = async () => {
    const spinCount = await axios.get("api/user/while/spin/count");
  };

  const getCurrentPlan = async () => {
    const response = await axios.post("/api/loyalty-wallet", {
      action: "current_plan",
    });
    if (response.status === 200) {
      setCurrentPlan(response.data.results);
      if (response.data.results.wheel_spin_allowed === response.data.results.wheel_spin_count) {
        setLimitExceeded(true);
      }
    }
  };

  const updateWheelSpinCount = async () => {
    await axios.post("/api/loyalty-wallet", {
      action: "wheel_spin_count_update",
    });
    getCurrentPlan();
  };

  const submitReferral = async () => {
    if (submitReferralCode.length === 0) {
      swal("Error", "Please enter a valid referral code", "error");
      return;
    }
    const response = await axios.post("/api/loyalty-wallet", {
      action: "wheel_referral_update",
      wheel_referral_code: submitReferralCode,
    });
    if (response.status === 200) {
      const message = response.data.results.message;
      if(response.data.results.message === "Congratulations, you have successfully won the chance."){
        setReferModal(false);
        const responseNotification = await axios.post("/api/send/referral/notification", {
          user_id: response.data.results.own_referral_id,
          title: "অভিনন্দন",
          body: "আপনি আরো একটি স্পিন করার সুযোগ পেয়েছেন।",
        });
      }
      setLimitExceeded(false);
      swal(message.includes("sorry") ? "Error" : "Success", message, message.includes("sorry") ? "error" : "success");
    }
    getCurrentPlan();
  };

  const handleReferralCodeInput = (event) => {
    setSubmitReferralCode(event.target.value);
  };

  function convertToBanglaNumber(num) {
    const banglaDigits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
    return num.toString().split('').map(digit => banglaDigits[parseInt(digit)]).join('');
}

  useEffect(() => {
    updateHomeModalViewed();
    getCurrentPlan();
    getReferCode();
    remainingSpinCount();
  }, []);

  return (
    <div className="main-container-lucky">
      {limitExceeded && !tryAgainModal ? (
        <div id="refer_section">
          <div>
            <div>আরো {convertToBanglaNumber(20 - referDoneCodes.length)} টি স্পিন করার সুযোগ গ্রহণ করতে</div>
              <p
                className="fs-5 btn btn-sm"
                style={{
                  color: "#000",
                  background: "#ffca2c",
                  margin: "0px 5px",
                  cursor: "pointer"
                }}
                onClick={() => {
                  setReferModal(true);
                  getReferCode();
                }}
                >
                ক্লিক করুন
                <img
                  src="/click.gif"
                  style={{
                    position: "absolute", // Corrected typo here
                    marginTop: "14px",
                    marginLeft: "-20px",
                  }}
                  alt="Click"
                />
              </p>
          </div>
        </div>
      ) : (
        "<div></div>"
      )}

      <div id="spinner">
        <div
          id="spinner-inner"
          style={transitionData}
          onTransitionEnd={spinTransitionEnd}
        >
          <svg viewBox="0 0 400 400" height="100%" width="100%" font-size="12">
            <defs>
              <mask id="mask">
                <rect width="400" height="400" fill="#000"></rect>
                <circle cx="200" cy="200" r="190" fill="#fff"></circle>
              </mask>

              <path id="t0" d="M360.407 235.012 L219.703 203.430" />

              <path id="t1" d="M317.8 312 L216.9 210.7" />

              <path id="t2" d="M242.8 360.7 L216.9 250.7" />

              <path
                id="t3"
                d="M160.24987700900368 360.7686941707879L204.3714145153147 219.5164221909472"
              ></path>

              <path
                id="t4"
                d="M85.98792846391112 318.40729555941846L196.57004896730413 219.7036909210764"
              ></path>

              <path
                id="t5"
                d="M42.29504575008217 240.7984490751537 L189.29086237143795 205.89125132287472"
              ></path>

              <path
                id="t6"
                d="M40.86789288327762 160.68862851547397L183.64204490094602 200.50727183033987"
              ></path>

              <path
                id="t7"
                d="M75.23130582921209 95.24987700900374 L185.4835778090528 185.3714145153147"
              ></path>

              <path
                id="t8"
                d="M155.592704440581514 35.9879284639111L180.2963090789236 146.57004896730413"
              ></path>

              <path
                id="t9"
                d="M242.20155092484626 35.2950457500822L183.10874867712528 250.29086237143795"
              ></path>

              <path
                id="t10"
                d="M318.31137148452606 78.86789288327762 L201.49272816966013 193.64204490094602"
              ></path>

              <path
                id="t11"
                d="M362.75012299099626 158.23130582921212L195.6285854846853 195.4835778090528"
              ></path>

              <linearGradient
                id="border_radient"
                gradientTransform="rotate(90)"
              >
                <stop offset="6.5%" stopColor="#FADE7A" />
                <stop offset="24.5%" stopColor="#FDE992" />
                <stop offset="42.5%" stopColor="#985800" />
                <stop offset="60%" stopColor="#E7C760" />
                <stop offset="76.5%" stopColor="#FAE176" />
                <stop offset="94%" stopColor="#995901" />
              </linearGradient>
            </defs>
            <g>
              <circle cx="200" cy="200" r="190" fill="var(--wheel)"></circle>
              <g style={{ mask: "url(#mask)" }}>
                <path
                  d="M200 200 L390 200 A190 190 0 0 1 367.819 297.057 Z"
                  fill="#4CAF50"
                />
                <path
                  d="M200 200 L367.819 297.057 A190 190 0 0 1 297.057 367.819 Z"
                  fill="#00A8A8"
                />
                <path
                  d="M200 200 L297.057 367.819 A190 190 0 0 1 200 390 Z"
                  fill="#d12438"
                />
                <path
                  d="M200 200 L200 390 A190 190 0 0 1 102.943 367.819 Z"
                  fill="#3f6357"
                />
                <path
                  d="M200 200 L102.943 367.819 A190 190 0 0 1 32.181 297.057 Z"
                  fill="#1976D2"
                />
                <path
                  d="M200 200 L32.181 297.057 A190 190 0 0 1 10 200 Z"
                  fill="#d12438"
                />
                <path
                  d="M200 200 L10 200 A190 190 0 0 1 32.181 102.943 Z"
                  fill="#FF9800"
                />
                <path
                  d="M200 200 L32.181 102.943 A190 190 0 0 1 102.943 32.181 Z"
                  fill="#9E9D24"
                />
                <path
                  d="M200 200 L102.943 32.181 A190 190 0 0 1 200 10 Z"
                  fill="#d12438"
                />
                <path
                  d="M200 200 L200 10 A190 190 0 0 1 297.057 32.181 Z"
                  fill="#5D4037"
                />
                <path
                  d="M200 200 L297.057 32.181 A190 190 0 0 1 367.819 102.943 Z"
                  fill="#3F51B5"
                />
                <path
                  d="M200 200 L367.819 102.943 A190 190 0 0 1 390 200 Z"
                  fill="#d12438"
                />
              </g>
              <circle
                cx="200"
                cy="200"
                r="190"
                fill="transparent"
                strokeWidth="15"
                stroke="url('#border_radient')"
              ></circle>
              <circle
                cx="200"
                cy="200"
                r="186"
                fill="transparent"
                strokeWidth="15"
                stroke="url('#border_radient')"
              ></circle>
              <circle
                cx="200"
                cy="200"
                r="178"
                fill="transparent"
                strokeWidth="1.5"
                stroke="black"
              ></circle>
              <g fill="var(--pins)">
                <circle cx="386" cy="200" r="2"></circle>
                <circle
                  cx="363.841593"
                  cy="106.820882"
                  r="6"
                  fill="url(#pointer_circle_1)"
                  stroke="url(#pointer_circle_2)"
                  stroke-width="3"
                />
                <circle
                  cx="387.841593"
                  cy="200.820882"
                  r="6"
                  fill="url(#pointer_circle_1)"
                  stroke="url(#pointer_circle_2)"
                  stroke-width="3"
                />
                <circle
                  cx="362.841593"
                  cy="294.320882"
                  r="6"
                  fill="url(#pointer_circle_1)"
                  stroke="url(#pointer_circle_2)"
                  stroke-width="3"
                />
                <circle
                  cx="293.841593"
                  cy="362.820882"
                  r="6"
                  fill="url(#pointer_circle_1)"
                  stroke="url(#pointer_circle_2)"
                  stroke-width="3"
                />
                <circle
                  cx="198.841593"
                  cy="387.820882"
                  r="6"
                  fill="url(#pointer_circle_1)"
                  stroke="url(#pointer_circle_2)"
                  stroke-width="3"
                />
                <circle
                  cx="36.841593"
                  cy="293.620882"
                  r="6"
                  fill="url(#pointer_circle_1)"
                  stroke="url(#pointer_circle_2)"
                  stroke-width="3"
                />
                <circle
                  cx="106.541593"
                  cy="363.620882"
                  r="6"
                  fill="url(#pointer_circle_1)"
                  stroke="url(#pointer_circle_2)"
                  stroke-width="3"
                />
                <circle
                  cx="11.841593"
                  cy="197.820882"
                  r="6"
                  fill="url(#pointer_circle_1)"
                  stroke="url(#pointer_circle_2)"
                  stroke-width="3"
                />
                <circle
                  cx="37.441593"
                  cy="104.820882"
                  r="6"
                  fill="url(#pointer_circle_1)"
                  stroke="url(#pointer_circle_2)"
                  stroke-width="3"
                />
                <circle
                  cx="105.641593"
                  cy="37.320882"
                  r="6"
                  fill="url(#pointer_circle_1)"
                  stroke="url(#pointer_circle_2)"
                  stroke-width="3"
                />
                <circle
                  cx="201.841593"
                  cy="11.820882"
                  r="6"
                  fill="url(#pointer_circle_1)"
                  stroke="url(#pointer_circle_2)"
                  stroke-width="3"
                />
                <circle
                  cx="294.641593"
                  cy="37.520882"
                  r="6"
                  fill="url(#pointer_circle_1)"
                  stroke="url(#pointer_circle_2)"
                  stroke-width="3"
                />

                <defs>
                  <linearGradient
                    id="pointer_circle_1"
                    x1="10.1703"
                    y1="0.0816593"
                    x2="10.1703"
                    y2="20.2587"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.065" stop-color="#996900" />
                    <stop offset="0.245" stop-color="#FFF5C2" />
                    <stop offset="0.425" stop-color="#FFDE62" />
                    <stop offset="0.6" stop-color="#8A500E" />
                    <stop offset="0.765" stop-color="#521D00" />
                    <stop offset="0.94" stop-color="#D9A125" />
                  </linearGradient>
                  <linearGradient
                    id="pointer_circle_2"
                    x1="10.1703"
                    y1="0.0816593"
                    x2="10.1703"
                    y2="20.2587"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#272727" />
                    <stop offset="0.175" stop-color="#202020" />
                    <stop offset="0.385" stop-color="#393939" />
                    <stop offset="0.605" stop-color="#1E1E1E" />
                    <stop offset="0.78" stop-color="#2F2F2F" />
                    <stop offset="1" stop-color="#111111" />
                  </linearGradient>
                </defs>
              </g>
              <text fill="var(--i)">
                <textPath href="#t0" dy="-50" className="textPathName1">
                  Try again
                </textPath>
              </text>
              <text fill="var(--i)">
                <textPath href="#t1" className="textPathName1">
                  Single Cap
                </textPath>
              </text>
              <text fill="var(--i)">
                <textPath href="#t2" className="textPathName1">
                  Try again
                </textPath>
              </text>
              <text fill="var(--i)">
                <textPath href="#t3" className="textPathName2">
                  Samsung TV 42''
                </textPath>
              </text>
              <text fill="var(--i)">
                <textPath href="#t4" className="textPathName1">
                  Try again
                </textPath>
              </text>
              <text fill="var(--i)">
                <textPath href="#t5" className="textPathName2">
                  আবার চেষ্টা করুন
                </textPath>
              </text>
              <text fill="var(--i)">
                <textPath href="#t6" className="textPathName3">
                  iPhone 16 Pro Max
                </textPath>
              </text>
              <text fill="var(--i)">
                <textPath href="#t7" className="textPathName2">
                  আবার চেষ্টা করুন
                </textPath>
              </text>
              <text fill="var(--i)">
                <textPath href="#t8" className="textPathName1">
                  Try again
                </textPath>
              </text>
              <text fill="var(--i)">
                <textPath href="#t9" className="textPathName3">
                  Single Power bank
                </textPath>
              </text>
              <text fill="var(--i)">
                <textPath href="#t10" className="textPathName">
                  Samsung Phone A Series
                </textPath>
              </text>
              <text fill="var(--i)">
                <textPath href="#t11" className="textPathName2">
                  আবার চেষ্টা করুন
                </textPath>
              </text>
            </g>
            <circle
              cx="227"
              cy="167"
              r="25"
              transform="rotate(10.8604 40.4288 40.6531)"
              stroke="url(#paint1_linear_802_23)"
              strokeWidth="6"
            />
            <circle
              cx="227"
              cy="167"
              r="25"
              transform="rotate(10.8604 40.4288 40.6531)"
              stroke="url(#paint0_linear_802_23)"
              strokeWidth="6"
            />
            <circle
              cx="227"
              cy="167"
              r="22"
              transform="rotate(10.8604 40.4288 40.6531)"
              fill="black"
            />
            <circle
              onClick={spinClicker}
              cx="228.5"
              cy="164.9"
              r="21"
              transform="rotate(10.8604 30.4291 30.6531)"
              fill="url(#paint0_linear_802_24)"
              stroke="#4B4B4B"
            />
            <defs>
              <linearGradient
                id="paint0_linear_802_23"
                x1="40.4288"
                y1="0.653061"
                x2="40.4288"
                y2="80.6531"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.065" stopColor="#996900" />
                <stop offset="0.245" stopColor="#FFF5C2" />
                <stop offset="0.425" stopColor="#FFDE62" />
                <stop offset="0.6" stopColor="#8A500E" />
                <stop offset="0.765" stopColor="#521D00" />
                <stop offset="0.94" stopColor="#D9A125" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_802_23"
                x1="40.4288"
                y1="0.653061"
                x2="40.4288"
                y2="80.6531"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.065" stopColor="#FFD644" />
                <stop offset="0.245" stopColor="#FDE992" />
                <stop offset="0.425" stopColor="#935500" />
                <stop offset="0.6" stopColor="#E7C760" />
                <stop offset="0.765" stopColor="#FAE176" />
                <stop offset="0.94" stopColor="#995901" />
              </linearGradient>
              <linearGradient
                id="paint0_linear_802_24"
                x1="30.4291"
                y1="0.65308"
                x2="30.4291"
                y2="60.6531"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#272727" />
                <stop offset="0.175" stopColor="#202020" />
                <stop offset="0.385" stopColor="#393939" />
                <stop offset="0.605" stopColor="#1E1E1E" />
                <stop offset="0.78" stopColor="#2F2F2F" />
                <stop offset="1" stopColor="#111111" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div
          id="ticker"
          style={{
            transformOrigin: "50% 1%",
            transitionDuration: "0.08s",
            transitionTimingFunction: "ease-in-out",
            transform: `rotate(${tickerDeg}deg)`,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <svg
            width="95"
            height="94"
            viewBox="0 0 140 140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              marginTop: -10,
            }}
          >
            <g filter="url(#filter0_d_802_51)">
              <path
                d="M54.4207 74.3524C52.0992 78.5262 50.9384 80.6131 49.4001 81.2902C48.1166 81.8551 46.6549 81.8551 45.3715 81.2902C43.8332 80.6131 42.6724 78.5262 40.3508 74.3524L9.32355 18.5708C7.50283 15.2974 6.59247 13.6608 6.68631 12.1947C6.76498 10.9655 7.29463 9.80858 8.17369 8.94576C9.2221 7.91673 11.0559 7.53633 14.7234 6.77553L25.6929 4.5L45.7507 0.339191C46.3676 0.211224 46.676 0.147236 46.9874 0.122349C47.2526 0.101154 47.519 0.101154 47.7842 0.122349C48.0956 0.147236 48.404 0.211224 49.0209 0.339192L80.0482 6.77554C83.7157 7.53634 85.5495 7.91674 86.5979 8.94577C87.4769 9.80859 88.0066 10.9655 88.0853 12.1948C88.1791 13.6608 87.2687 15.2974 85.448 18.5708L54.4207 74.3524Z"
                fill="url(#paint0_linear_802_51)"
              />
              <path
                d="M48.3929 79.002L49.4001 81.2902L48.3929 79.002C47.7512 79.2845 47.0204 79.2845 46.3786 79.002L45.3715 81.2902L46.3786 79.002C46.2663 78.9526 45.9192 78.7443 45.2175 77.7198C44.5263 76.7107 43.7209 75.2681 42.5356 73.1372L11.5083 17.3555C10.5748 15.6773 9.95948 14.566 9.57294 13.6929C9.19243 12.8335 9.17215 12.4959 9.1812 12.3544C9.22054 11.7398 9.48537 11.1613 9.9249 10.7299C10.0261 10.6306 10.2949 10.4254 11.1941 10.1518C12.1075 9.8739 13.3508 9.61348 15.2312 9.22341L26.2007 6.94789L46.2585 2.78707C46.9337 2.64701 47.0664 2.624 47.1866 2.6144C47.3192 2.6038 47.4524 2.6038 47.5851 2.61441C47.7051 2.624 47.8379 2.64701 48.5131 2.78708L79.5404 9.22343C81.4207 9.61349 82.6641 9.87391 83.5775 10.1518C84.4767 10.4254 84.7455 10.6306 84.8467 10.7299C85.2862 11.1614 85.551 11.7398 85.5904 12.3544C85.5994 12.4959 85.5791 12.8335 85.1986 13.6929C84.8121 14.566 84.1968 15.6773 83.2633 17.3555L52.236 73.1371C51.0507 75.2681 50.2453 76.7107 49.5541 77.7198C48.8524 78.7443 48.5052 78.9526 48.3929 79.002Z"
                stroke="url(#paint1_linear_802_51)"
                stroke-width="5"
              />
            </g>
            <g filter="url(#filter1_d_802_51)">
              <circle
                cx="47.3858"
                cy="36.9024"
                r="5.70732"
                transform="rotate(90 47.3858 36.9024)"
                fill="url(#paint2_linear_802_51)"
              />
              <circle
                cx="47.3858"
                cy="36.9024"
                r="5.20732"
                transform="rotate(90 47.3858 36.9024)"
                stroke="url(#paint3_linear_802_51)"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_802_51"
                x="0.679718"
                y="0.106461"
                width="93.4121"
                height="93.6074"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="6" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_802_51"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_802_51"
                  result="shape"
                />
              </filter>
              <filter
                id="filter1_d_802_51"
                x="37.6785"
                y="27.1951"
                width="19.4146"
                height="19.4146"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feMorphology
                  radius="1"
                  operator="dilate"
                  in="SourceAlpha"
                  result="effect1_dropShadow_802_51"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_802_51"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_802_51"
                  result="shape"
                />
              </filter>
              <linearGradient
                id="paint0_linear_802_51"
                x1="47.3858"
                y1="87"
                x2="47.3858"
                y2="3.83649e-06"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#272727" />
                <stop offset="0.175" stop-color="#202020" />
                <stop offset="0.385" stop-color="#393939" />
                <stop offset="0.605" stop-color="#1E1E1E" />
                <stop offset="0.78" stop-color="#2F2F2F" />
                <stop offset="1" stop-color="#111111" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_802_51"
                x1="47.3858"
                y1="87"
                x2="47.3858"
                y2="-17"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.065" stop-color="#FADE7A" />
                <stop offset="0.245" stop-color="#FDE992" />
                <stop offset="0.425" stop-color="#985800" />
                <stop offset="0.6" stop-color="#E7C760" />
                <stop offset="0.765" stop-color="#FAE176" />
                <stop offset="0.94" stop-color="#995901" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_802_51"
                x1="47.3858"
                y1="31.1951"
                x2="47.3858"
                y2="42.6098"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.065" stop-color="#996900" />
                <stop offset="0.245" stop-color="#FFF5C2" />
                <stop offset="0.425" stop-color="#FFDE62" />
                <stop offset="0.6" stop-color="#8A500E" />
                <stop offset="0.765" stop-color="#521D00" />
                <stop offset="0.94" stop-color="#D9A125" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_802_51"
                x1="47.3858"
                y1="31.1951"
                x2="47.3858"
                y2="42.6098"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.065" stop-color="#FADE7A" />
                <stop offset="0.245" stop-color="#FDE992" />
                <stop offset="0.425" stop-color="#985800" />
                <stop offset="0.6" stop-color="#E7C760" />
                <stop offset="0.765" stop-color="#FAE176" />
                <stop offset="0.94" stop-color="#995901" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>

      <a
        onClick={spinSubmit ? spinClicker : null} // Disable click when spinSubmit is false
        href="javascript:void(0)"
        style={{
          zIndex: 100,
          width: "130px",
          display: "inline-block",
          position: "relative",
          marginLeft: "44%",
          pointerEvents: spinSubmit ? "auto" : "none", // Disable pointer events if false
          opacity: spinSubmit ? 1 : 0.5, // Optionally reduce opacity to indicate it's disabled
          background: "rgb(255, 202, 44)",
          color: "black",
          borderRadius: "5px",
          marginTop: "15px",
        }}
      >
        <div
          style={{
            padding: "5px 0px",
            textAlign: "center",
            textTransform: "uppercase",
            fontWeight: "bold",
            animation: spinSubmit ? "spin 1s linear infinite" : "none",
            fontSize: "20px",
          }}
        >
          {spinSubmit ? <span>Spin</span> : <span>Spinning</span>}
        </div>
      </a>

      <LuckySpinTicketQRModal
        sx={{
          backgroundColor: "#25272b",
          p: 3,
          py: 2,
          height: "70vH",
          overflow: "auto",
          width: { xs: "90%", sm: "40%" },
          color: "rgb(194, 194, 194)",
          zIndex: 200,
          display: "flex",
          alignItems: "center",
        }}
        open={ticketQRModal}
      >
        <div
          style={{
            textAlign: "center",
          }}
        >
          <div
            style={{
              top: 5,
              right: 5,
              position: "absolute",
            }}
          >
            <a
              href="javascript:void(0)"
              onClick={() => setTicketQRModal(false)}
            >
              <FontAwesomeIcon icon={faTimes} style={{ fontSize: 25 }} />
            </a>
          </div>
          <div className="text-left">
            <h1>Congratulations! You’ve won a free ticket!</h1>
            <div>
              Please{" "}
              <a
                className="fs-5"
                style={{ color: "yellow" }}
                href="https://play.google.com/store/apps/details?id=com.hellosuperstars"
                target="__blank"
              >
                download
              </a>{" "}
              our app Hello Superstar from the Play Store to receive your
              ticket.
            </div>
          </div>
          <div></div>
        </div>
      </LuckySpinTicketQRModal>

      <LuckySpinTicketQRModal
        sx={{
          backgroundColor: "#25272b",
          p: 3,
          pt: 5,
          pl: 5,
          height: "auto", // Let the height adjust based on content
          maxHeight: "80vh", // Ensure it doesn’t exceed 80% of the viewport height
          overflowY: "auto", // Allow scrolling if content exceeds maxHeight
          width: { xs: "90%", sm: "45%" },
          color: "rgb(194, 194, 194)",
          zIndex: 200,
        }}
        open={referModal}
      >
        <div
          style={{
            textAlign: "center",
          }}
        >
          <div
            style={{
              top: 5,
              right: 5,
              position: "absolute",
            }}
          >
            <a
              href="javascript:void(0)"
              onClick={() => {
                setReferModal(false);
                setSubmitReferralCode("");
                setSubmitConditionModal(false);
                setReferConditionModal(false);
              }}
            >
              <FontAwesomeIcon icon={faTimes} style={{ fontSize: 25 }} />
            </a>
          </div>
          <div className="text-left">
            <div id="refer_section">
              <div>
                
                <p className="mt-4">
                নিচের ২০ টি কোড হতে ১টি করে কোড আপনার ২০ জন বন্ধুকে পাঠান, কোডটি ২৪ ঘন্টার মধ্যে আপনার বন্ধু ব্যবহার করলেই আপনি পেয়ে যাবেন পুনরায় স্পিন করার সুযোগ ।
                </p>

                <div
                  id="ref-code-input"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "7px",
                    justifyContent: "flex-start",
                    marginTop: "10px",
                  }}
                >
                  {referCodes.map((referCode, index) => {
                    const isMatched = referDoneCodes.includes(referCode); // Check if the referCode exists in referDoneCodes array

                    return (
                      <div
                        key={index}
                        style={{
                          flex: "0 1 100px",
                          textAlign: "center",
                          backgroundColor: isMatched ? "" : "", // Change color if matched
                        }}
                      >
                        <p
                          className="form-control text-dark refer_code_btn"
                          onClick={async () => {
                            if (!isMatched) {
                              // Only copy if the refer code is not matched
                              await navigator.clipboard.writeText(referCode);
                              swal(
                                "Copied",
                                "The code has been copied to clipboard",
                                "success"
                              );
                            } else {
                              swal(
                                "Already Used",
                                "This code is already marked as success",
                                "info"
                              );
                            }
                          }}
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            backgroundColor: isMatched ? "white" : "gold", // Change background color if matched
                            cursor: "pointer"
                          }}
                        >
                          {referCode}
                        </p>
                      </div>
                    );
                  })}
                </div>

                <div className="referSubmitBox border p-4 pb-2">
                  <div>
                  পুনরায় স্পিন করার জন্য যে রেফারেল কোডটি পেয়েছেন তা লিখুন, Submit বাটনে ক্লিক করুন এবং পুনরায় ভাগ্য পরীক্ষা করুন, শুভকামনা ।
                  </div>

                  <div id="ref-get-chance">
                    <div
                      id="ref-get-chance-input"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <div>
                        <input
                          type="text"
                          className="form-control referSubmitInput"
                          onChange={handleReferralCodeInput}
                          placeholder="Enter Code"
                        />
                      </div>
                      <div>
                        <a
                          id="refer-get-chance-btn"
                          className="form-control text-dark"
                          href="javascript:void(0)"
                          onClick={submitReferral}
                        >
                          SUBMIT
                        </a>
                      </div>
                    </div>
                  </div>
                  {/* <div className="text-end">
                    <p
                      className="border d-inline p-1"
                      style={{ cursor: "pointer", fontSize: "14px" }}
                      onClick={() => {
                        setSubmitConditionModal(true);
                        setReferModal(false);
                      }}
                    >
                      Condition Applied{" "}
                      <i className="fa-solid fa-circle-info"></i>
                    </p>
                  </div> */}
                </div>
              </div>
            </div>
            {/* <div className="text-center">
              <p
                className="border d-inline p-1 text-white"
                style={{ cursor: "pointer", fontSize: "14px" }}
                onClick={() => {
                  setReferConditionModal(true);
                  setReferModal(false);
                }}
              >
                Condition Applied <i className="fa-solid fa-circle-info"></i>
              </p>
            </div> */}
          </div>
          <div></div>
        </div>
      </LuckySpinTicketQRModal>

      <LuckySpinPhysicalProductModal
        sx={{
          backgroundColor: "#25272b",
          p: 3,
          py: 2,
          height: "62vH",
          overflow: "auto",
          width: { xs: "90%", sm: "40%" },
          color: "rgb(194, 194, 194)",
          zIndex: 200,
        }}
        open={physicalProductModal}
      >
        <div>
          <div className="col-md-8 col-12 mx-auto">
            <div
              style={{
                top: 5,
                right: 5,
                position: "absolute",
              }}
            >
              <a
                href="javascript:void(0)"
                onClick={() => setPhysicalProductModal(false)}
              >
                <FontAwesomeIcon icon={faTimes} style={{ fontSize: 25 }} />
              </a>
            </div>
            <div
              style={{
                marginTop: 20,
              }}
            >
              <div className="text-center">
                Congratulations! You've won a {winPhysicalProduct}! Please
                provide the necessary information and claim your gift at the
                following address 7021, DOHA, QATAR., Abu Hamour, Qatar
              </div>
              <div className="form-group my-3">
                <label className="text-white">Product</label>
                <select
                  name="name1"
                  className="form-control input-overlay"
                  onChange={handlePhysicalProductInput}
                >
                  <option value={winPhysicalProduct}>
                    {winPhysicalProduct != null
                      ? winPhysicalProduct.replace("/_/g", " ").toUpperCase()
                      : ""}
                  </option>
                </select>
                <small id="emailHelp" className="form-text text-danger"></small>
              </div>
              <div className="form-group my-3">
                <big className="text-white">Name</big>
                <input
                  type="text"
                  className="form-control input-overlay"
                  name="name"
                  onChange={handlePhysicalProductInput}
                />
                <small id="emailHelp" className="form-text text-danger"></small>
              </div>
              <div className="form-group my-3">
                <big className="text-white">Email</big>
                <input
                  type="text"
                  className="form-control input-overlay"
                  name="email"
                  onChange={handlePhysicalProductInput}
                />
                <small id="emailHelp" className="form-text text-danger"></small>
              </div>
              <div className="form-group my-3">
                <big className="text-white">Phone</big>
                <input
                  type="text"
                  className="form-control input-overlay"
                  name="phone"
                  onChange={handlePhysicalProductInput}
                />
                <small id="emailHelp" className="form-text text-danger"></small>
              </div>
              {/* <div className="form-group my-3">
                <big className="text-white">Address</big>
                <input
                  type="text"
                  className="form-control input-overlay"
                  name="address"
                  onChange={handlePhysicalProductInput}
                />
                <small id="emailHelp" className="form-text text-danger"></small>
              </div> */}
              <div className="text-center">
                <button
                  type="submit"
                  className="my-3 btn btn-gold submit-greetings-btn"
                  onClick={submitPhysicalProduct}
                >
                  {" "}
                  Submit{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </LuckySpinPhysicalProductModal>

      <LuckySpinTryAgainModal
        sx={{
          backgroundColor: "#25272b",
          p: 3,
          py: 2,
          height: "34vH",
          overflow: "auto",
          width: { xs: "90%", sm: "33%" },
          color: "rgb(194, 194, 194)",
          zIndex: 200,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        open={tryAgainModal}
      >
        <div
          style={{
            textAlign: "center",
          }}
        >
          <div
            style={{
              right: 15,
              top: 15,
              position: "absolute",
            }}
          >
            <a
              href="javascript:void(0)"
              onClick={() => settryAgainModal(false)}
            >
              <FontAwesomeIcon icon={faTimes} style={{ fontSize: 25 }} />
            </a>
          </div>
          <div
            style={{
              marginTop: "10px",
            }}
          >
            <div className="mb-3">মিস করেছেন? হতাশ হওয়ার কিছু নেই</div>
            <h3>আরো {convertToBanglaNumber(20 - referDoneCodes.length)} টি স্পিন করার সুযোগ গ্রহণ করতে</h3>
            <p
                className="fs-5 btn btn-sm"
                style={{
                  color: "#000",
                  background: "#ffca2c",
                  margin: "0px 5px",
                  cursor: "pointer"
                }}
                onClick={() => {
                  setReferModal(true);
                  getReferCode();
                  settryAgainModal(false);
                }}
                >
                ক্লিক করুন
                <img
                  src="/click.gif"
                  style={{
                    position: "absolute", // Corrected typo here
                    marginTop: "14px",
                    marginLeft: "-20px",
                  }}
                  alt="Click"
                />
              </p>
          </div>
        </div>
      </LuckySpinTryAgainModal>

      <LuckySpinTryAgainModal
        sx={{
          backgroundColor: "#25272b",
          p: 3,
          py: 2,
          height: "32vH",
          overflow: "auto",
          width: { xs: "90%", sm: "31%" },
          color: "rgb(194, 194, 194)",
          zIndex: 200,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        open={giftCodeModal}
      >
        <div
          style={{
            textAlign: "center",
          }}
        >
          <div
            style={{
              right: 15,
              top: 15,
              position: "absolute",
            }}
          >
            <a
              href="javascript:void(0)"
              onClick={() => setGiftCodeModal(false)}
            >
              <FontAwesomeIcon icon={faTimes} style={{ fontSize: 25 }} />
            </a>
          </div>
          <div
            style={{
              marginTop: "10px",
            }}
          >
            <div className="text-center">
              <span style={{ fontSize: "25px" }}>Please submit this code</span>{" "}
              <br />
              <span>
                <strong style={{ fontSize: "35px" }}>
                  {giftCode ? giftCode : ""}
                </strong>
              </span>{" "}
              <br />
              <span style={{ fontSize: "25px" }}>
                to the dedicated booth during claiming your gift.
              </span>
            </div>
          </div>
        </div>
      </LuckySpinTryAgainModal>

      <LuckySpinTicketQRModal
        sx={{
          backgroundColor: "#25272b",
          p: 3,
          pt: 5,
          pl: 5,
          height: "auto",
          overflow: "auto",
          width: { xs: "90%", sm: "45%" },
          color: "rgb(194, 194, 194)",
          zIndex: 200,
        }}
        open={submitConditionModal}
      >
        <div
          style={{
            textAlign: "center",
          }}
        >
          <div
            style={{
              top: 5,
              right: 5,
              position: "absolute",
            }}
          >
            <a
              href="javascript:void(0)"
              onClick={() => {
                setSubmitConditionModal(false);
                setReferModal(true);
              }}
            >
              <FontAwesomeIcon icon={faTimes} style={{ fontSize: 25 }} />
            </a>
          </div>
          <div className="text-left">
            <div id="refer_section">
              <div>
                <p className="border-bottom">Terms & Conditions</p>
                <p className="text-start">
                  1. This code is valid for one-time use only.
                </p>
                <p className="text-start">
                  2. The code is valid for 24 hours only.
                </p>
              </div>
            </div>
          </div>
          <div className="text-white">Use it before it expires and enjoy the benefits!</div>
        </div>
      </LuckySpinTicketQRModal>

      <LuckySpinTicketQRModal
        sx={{
          backgroundColor: "#25272b",
          p: 3,
          pt: 5,
          pl: 5,
          height: "auto",
          overflow: "auto",
          width: { xs: "90%", sm: "45%" },
          color: "rgb(194, 194, 194)",
          zIndex: 200,
        }}
        open={referConditionModal}
      >
        <div
          style={{
            textAlign: "center",
          }}
        >
          <div
            style={{
              top: 5,
              right: 5,
              position: "absolute",
            }}
          >
            <a
              href="javascript:void(0)"
              onClick={() => {
                setReferConditionModal(false);
                setReferModal(true);
              }}
            >
              <FontAwesomeIcon icon={faTimes} style={{ fontSize: 25 }} />
            </a>
          </div>
          <div className="text-left">
            <div id="refer_section">
              <div>
                <p className="border-bottom">Terms & Conditions</p>
                <p className="text-start">
                  1. This code is valid for 24 hours only.
                </p>
                <p className="text-start">
                  2. Each code can be used by one user only.
                </p>
                <p className="text-start">
                  3. You can share the code with up to 20 people.
                </p>
              </div>
            </div>
          </div>
          <div>Make sure to use it before it expires and share it wisely!</div>
        </div>
      </LuckySpinTicketQRModal>
    </div>
  );
};

export default LuckySpin;
